import { FormlyFieldConfig } from '@ngx-formly/core';
import { LuFormlyBuilder } from '../formly.builder';
import { FieldType, ValueLabel } from './formly-builder.models';

export class LuFormlyToggleButtonBuilder extends LuFormlyBuilder {
	protected type = FieldType.TOOGLE_BUTTON;
	private options: ValueLabel;
	private icon: string;

	constructor(key: string, options: ValueLabel, label: string, className?: string) {
		super(key, label, null, className);
		this.options = options;
	}

	public setIcon(icon: string): this {
		this.icon = icon;
		return this;
	}

	public build(): FormlyFieldConfig {
		const field = super.build();
		field.templateOptions.options = [this.options];
		field.templateOptions.icon = this.icon;
		return field;
	}
}
